import * as usuarioActions from './usuarioActions';

export const INITIAL_STATE = {
  usuarios: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case usuarioActions.SET_USUARIOS:
      return { ...state, usuarios: action.payload };

    default:
      return state;
  }
};
